import Chip from '@kareo/design-system/src/Chip';

angular
  .module('app.shared-components.chip', [
    'react'
  ])
  .directive('chip', chip);

chip.$inject = ['reactDirective'];

function chip(reactDirective) {
  const bindings = {
    type: '=',
    label: '=',
    clickable: '=',
  };
  return reactDirective(Chip, bindings, props=>{
    return props;
  });
}